import MuxPlayerClient from "@components/MuxPlayerClient"
import colors from "@constants/colors"
import React from "react"
import styled from "styled-components"

const VideoWrapper = styled.div<{
  $disablePlayback?: boolean
  $fullWidth?: boolean
  $hideControls?: boolean
}>`
  width: 100%;
  height: 100%;

  > * {
    height: 100%;
    --controls: ${({ $hideControls }) => $hideControls && "none"};
    --media-object-fit: cover;
    --media-object-position: center;
    object-fit: contain;
    object-position: center;
    aspect-ratio: ${({ $fullWidth }) => ($fullWidth ? "16/9" : "1/1")};
  }

  > mux-player::part(center play button) {
    display: flex;
    pointer-events: ${({ $disablePlayback }) =>
      $disablePlayback ? "none" : "auto"};
    background-color: ${colors.mediumDarkGray};
  }
`

interface DesktopPDPMuxPlayerProps {
  autoplayVideo?: boolean
  disablePlayback?: boolean
  fullWidth?: boolean
  hideControls?: boolean
  loopVideo?: boolean
  muxVideo?: {
    title: string
    video: {
      assetId: string
      audioOnly: boolean
      created_at: number
      duration: number
      max_stored_frame_rate: number
      max_stored_resolution: string
      playbackId: string
      ratio: string
      ready: boolean
      version: number
    }
  }
  onEnded?: () => void
  onPlaying?: (isMobile: boolean) => void
}

export default function DesktopPDPMuxPlayer({
  autoplayVideo = false,
  disablePlayback = false,
  fullWidth = false,
  hideControls = false,
  loopVideo = true,
  muxVideo,
}: DesktopPDPMuxPlayerProps) {
  const videoPlaybackId = muxVideo?.video.playbackId

  return (
    <VideoWrapper
      $disablePlayback={disablePlayback}
      $fullWidth={fullWidth}
      $hideControls={hideControls}
    >
      <MuxPlayerClient
        accentColor={colors.brandOrange}
        autoPlay={autoplayVideo ? "muted" : false}
        loop={loopVideo}
        nohotkeys={hideControls}
        playbackId={videoPlaybackId}
        streamType="on-demand"
      />
    </VideoWrapper>
  )
}
